export const onUnload = (data, url, assessmentTypeKey, isActivated) => {
  if (isActivated) {
    if (onUnload._hasUnloaded || assessmentTypeKey !== 1) {
      return;
    }

    onUnload._hasUnloaded = true;
    let text = JSON.stringify(data);
    let blob = new Blob([text], { type: 'application/json' });
    navigator.sendBeacon(url, blob);
  }
};
